/**
 * The demo's subject illustrations, chosen by what a category is called.
 *
 * `course_categories` has no image column and no attachment, so any art on a
 * category has to be derived from something the row already carries. Its name
 * is the only candidate, and it is stable: these are four seeded strings, not
 * user input.
 *
 * Keyword order matters — the specific words are matched before the generic
 * ones, so "คอร์สแพ็กเกจ" is not caught by the rule that serves
 * "คอร์สแนะนำระบบ". A category nothing matches gets no art, and the caller
 * falls back to what it drew before.
 *
 * The set itself came from the 2021 demo build and was recoloured into the
 * ink + spark palette; see assets/media/landing/subjects.
 */
const RULES: ReadonlyArray<readonly [readonly string[], string]> = [
  [["ข้อสอบ", "แบบฝึกหัด", "ทดสอบ", "quiz", "exam"], "clock-exam"],
  [["แพ็ก", "แพ็ค", "ชุดคอร์ส", "package", "bundle"], "mathematics"],
  [["พื้นฐาน", "บทเรียน", "basic", "lesson"], "one-two-three"],
  [["แนะนำ", "เริ่มต้น", "intro", "start"], "teacher"],
  [["คณิต", "math"], "mathematics"],
  [["วิทย", "science"], "science"],
  [["ภาษา", "อังกฤษ", "english", "language"], "four-five-six"],
  [["ติว", "เตรียมสอบ", "prep"], "medal"],
  [["วิดีโอ", "video"], "laptop"],
];

/** The icon path for a category name, or null when nothing matches. */
export function subjectArt(name?: string | null): string | null {
  const haystack = (name || "").toLowerCase();
  if (!haystack) return null;
  for (const [keywords, art] of RULES) {
    if (keywords.some((word) => haystack.includes(word))) {
      return `./assets/media/landing/subjects/${art}.svg`;
    }
  }
  return null;
}
